/** @format */
import "./pwa-listener";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./assests/styles/global.scss";
import "./assests/styles/antd.scss";
import "./assests/styles/common.scss";
import "./assests/styles/measurements.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import Layout from "./layout";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./store/store";
import axios from "axios";
import { BASE_URL } from "./utils/apiConfig";

axios.defaults.baseURL = BASE_URL;
axios.defaults.headers.common["Authorization"] = localStorage["token"]
  ? `Bearer ${localStorage.getItem("token")}`
  : "";

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then(() => console.log("SW registered"))
      .catch((err) => console.error("SW register failed", err));
  });
}
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Provider store={store}>
      <Layout>
        <App />
      </Layout>
    </Provider>
  </BrowserRouter>
);
